import { VueCropper } from 'vue-cropper';
export default {
  components: {
    VueCropper: VueCropper
  },
  data: function data() {
    return {
      //文档地址  https://github.com/xyxiao001/vue-cropper
      // ant-modal相关配置
      visible: false,
      confirmLoading: false,
      // vue-cropper相关配置 详细的可以去github上看文档
      img: null,
      //要裁剪的图像资源 可选项: url地址 || base64 || blob
      options: {
        autoCrop: true,
        //是否默认生成截图框
        autoCropWidth: 400,
        //默认生成截图框宽度
        autoCropHeight: 400,
        //默认生成截图框高度
        fixedBox: true,
        //固定截图框大小 不允许改变
        // infoTrue: true, // 为展示真实输出图片宽高 false 展示看到的截图框宽高
        fixed: true,
        // 是否开启截图框宽高固定比例
        fixedNumber: [1, 1],
        centerBox: false,
        // 截图框是否被限制在图片里面
        info: true,
        // 裁剪框的大小信息
        // enlarge 图片根据截图框输出比例倍数
        enlarge: 2,
        infoTrue: true,
        //true 为展示真实输出图片宽高 false 展示看到的截图框宽高
        // mode:'100px',
        outputType: 'png'
      }
    };
  },
  methods: {
    // 调用此方法需传入一个 [url地址 || base64 || blob]
    // 父组件调用: this.$refs['cropperModal'].edit(参数)
    edit: function edit(image) {
      this.img = image;
      this.visible = true;
    },
    // 监听对话框的OK/Cancel按钮的点击事件
    handleOk: function handleOk() {
      var that = this;
      that.confirmLoading = true;
      // 获取截图的base64 数据
      // getCropBlob获取二进制数据
      this.$refs.cropper.getCropData(function (data) {
        //将裁剪侯后的图片对象射给**父组件**,然后关闭对话框
        console.log(data);
        that.$emit('ok', data);
        that.handleCancel();
      });
    },
    handleCancel: function handleCancel(e) {
      this.visible = false;
      this.confirmLoading = false;
    }
  }
};